import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ClientField, UpdateSubscriptionSignupRequest } from '@fitness-force/models';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppErrors, NotFoundError } from '@fitness-force/errors';
import { environment } from 'apps/ff-frontend/src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class OpenapiService {
  constructor(private http: HttpClient) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  httpPatchOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json-patch+json',
    })
  };

  GetCompany(BASE_URL: string, companyId: number): Observable<any> {
    const url: string = BASE_URL + CONST_URL_SEGEMENTS.OPEN_API.GET_COMPANYBYID.replace('{company_id}', companyId.toString());

    return this.http.get(url, this.httpOptions).pipe(
      map(res => res),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  GetTenant(BASE_URL: string, tenantId: number): Observable<any> {
    const url: string = BASE_URL + CONST_URL_SEGEMENTS.OPEN_API.GET_TENANTBYID.replace('{tenant_id}', tenantId.toString());

    return this.http.get(url, this.httpOptions).pipe(
      map(res => res),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  GetMandatoryFields(BASE_URL: string, tenantId: number): Observable<string[]> {
    const _url = BASE_URL + CONST_URL_SEGEMENTS.OPEN_API.GET_MANDATORYFIELDS.replace('{tenant_id}', tenantId.toString());
    return this.http.get(_url, this.httpOptions).pipe(
      map((res: any) => res),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  PatchUpdateClientWithSubscription(BASE_URL: string, tenantId: number, body: any): Observable<ClientField[]> {
    const _url = BASE_URL + CONST_URL_SEGEMENTS.OPEN_API.PATCH_UPDATECLIENT.replace('{tenant_id}', tenantId.toString());
    return this.http.patch(_url, body, this.httpPatchOptions).pipe(
      map((res: any) => res),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  PatchUpdateClientInfoByUuid(BASE_URL: string, uuid: string, body: any): Observable<any> {
    const _url = BASE_URL + CONST_URL_SEGEMENTS.OPEN_API.PATCH_UPDATE_CLIENT_UUID.replace('{sigup_sts_uuid}', uuid);
    return this.http.patch(_url, body, this.httpPatchOptions).pipe(
      map((res: any) => res),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  UpdateSubscriptionSignup(BASE_URL: string, uuid: string, payload: UpdateSubscriptionSignupRequest): Observable<ClientField[]> {
    const _url = BASE_URL + CONST_URL_SEGEMENTS.OPEN_API.UPDATE_SUBSCRIPTION_SIGNUP.replace('{sigup_sts_uuid}', uuid.toString());
    return this.http.put(_url, payload, this.httpPatchOptions).pipe(
      map((res: any) => res),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }


   // Charge Master
   getCountries() {
    return this.http
      .get(
        `${environment.BASE_URL}/open/countries`,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }



  // Charge Master
  getStates(countryCode:string) {
    return this.http
      .get(
        `${environment.BASE_URL}/open/countries/${countryCode}/states`,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
    // Charge Master
    getCities(countryCode:string,stateCode:string) {
      return this.http
        .get(
          `${environment.BASE_URL}/open/countries/${countryCode}/states/${stateCode}/cities `,
          this.httpOptions
        )
        .pipe(
          map((res: any) => {
            return res;
          }),
          catchError((error: Response) => {
            if (error.status === 404) {
              return throwError(() => new NotFoundError(error));
            }
            return throwError(() => new AppErrors(error));
          })
        );
    }
}

